import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getparentsFeedback, deleteparentsFeedbacks } from '../../ReduxToolkit/Slice/Feedback/ParentsFeedback';


function ParentsFeedback() {
    const dispatch = useDispatch();
    const { status, parentsFeedbacks } = useSelector((state) => state.parentsFeedback);
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getparentsFeedback())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (parentsFeedbackid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Feedback?")
        if (Isconfirmed) {
            dispatch(deleteparentsFeedbacks(parentsFeedbackid))
        };
    }
    // single data fetch
    const [email, setEmail] = useState(null);
    const [wardName, setwardName] = useState("");
    const [programme, setProgramme] = useState("");
    const [batch, setBatch] = useState("");
    const [question1, setQuestion1] = useState("");
    const [question2, setQuestion2] = useState("");
    const [question3, setQuestion3] = useState("");
    const [question4, setQuestion4] = useState("");
    const [question5, setQuestion5] = useState("");
    const [question6, setQuestion6] = useState("");
    const [question7, setQuestion7] = useState("");
    const [question8, setQuestion8] = useState("");
    const [question9, setQuestion9] = useState("");
    const [question10, setQuestion10] = useState("");
    const [suggestion, setSuggestion] = useState("");

    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectedparentsFeedback = parentsFeedbacks.data.find(parentsFeedback => parentsFeedback._id === id);
        setEmail(selectedparentsFeedback.email);
        setwardName(selectedparentsFeedback.wardName);
        setProgramme(selectedparentsFeedback.programme);
        setBatch(selectedparentsFeedback.batch);
        setQuestion1(selectedparentsFeedback.question1);
        setQuestion2(selectedparentsFeedback.question2);
        setQuestion3(selectedparentsFeedback.question3);
        setQuestion4(selectedparentsFeedback.question4);
        setQuestion5(selectedparentsFeedback.question5);
        setQuestion6(selectedparentsFeedback.question6);
        setQuestion7(selectedparentsFeedback.question7);
        setQuestion8(selectedparentsFeedback.question8);
        setQuestion9(selectedparentsFeedback.question9);
        setQuestion10(selectedparentsFeedback.question10);
        setSuggestion(selectedparentsFeedback.suggestion);
        setSelectedId(id);
    };
    return (
        <>
            <div>
                <div className='d-flex justify-content-between my-3'>
                    <h3>Parents Feedbacks </h3>
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Ward Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Programme</th>
                                <th scope="col">Batch</th>
                                <th scope="col">date</th>

                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={8}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={8}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && parentsFeedbacks.data && parentsFeedbacks.data.map((parentsFeedback, index) => {
                                const newdate = new Date(parentsFeedback.createdAt);
                                const formattedDate = newdate.toLocaleDateString("default", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric"
                                });
                                return (
                                    <tr key={parentsFeedback._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{parentsFeedback.wardName}</td>
                                        <td>{parentsFeedback.email}</td>
                                        <td>{parentsFeedback.programme}</td>
                                        <td>{parentsFeedback.batch}</td>
                                        <td>{formattedDate}</td>
                                        <td className='cursor'>
                                            <div onClick={() => handlid(parentsFeedback._id)}><i className='bi bi-eye-fill text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                            <div onClick={() => handleDelete(parentsFeedback._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Parents Feedback
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Ward Name</h6>
                                        <h6 className='text-primary'>{wardName}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Email</h6>
                                        <h6 className='text-primary'>{email}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Programme</h6>
                                        <h6 className='text-primary'>{programme}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Batch</h6>
                                        <h6 className='text-primary'>{batch}</h6>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>1. The curriculum of the course is well designed and promotes learning experience

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question1}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>2. Curriculum is improving your ward's knowledge through interaction with faculty of the institute.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question2}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>3. The infrastructural facilities like classrooms, skill labs, auditoriums, etc. are developed according to the curriculum objective.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question3}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>

                                        <h6>4. The curriculum provides Opportunities for participation in various co-curricular activities (Visits, Intercollegiate participation, sports, cultural activities).

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question4}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>5. The curriculum was effective in improving the personality of your ward.

                                        </h6>                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question5}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>6. Library, internet, computers, and other learning resources are sufficient to meet the curriculum's objectives.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question6}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>Curriculum discipline (i.e., timely conduct of lectures, practicals and related activities) is well structured and timely monitored.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question7}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6> Development of communication skills, managerial skills and leadership skills are delivered through curriculum.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question8}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>The timely declaration of examination results enables you to monitor the progress of your ward at different stages of the curriculum.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question9}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6> The curriculum is easy to understand with the help of an informative and accessible college website.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question10}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 my-3 border rounded py-2">
                                    <div>
                                        <h6>SUGGESTIONS</h6>
                                        <p>{suggestion}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ParentsFeedback;
